import $ from '../utils/jquery';

const $section = $( '#state-quotes' );
const $select = $section.find( '#state-quote-select' );
const $wrapper = $section.find( '.results-wrapper' );
const $instructions = $section.find( '.select-instructions' );

const buildQuote = ( item ) => {
	const $quote = $( '<blockquote class="state-quote"></blockquote>' );
	$quote.append( $( '<p class="quote-text"></p>' ).text( item.val ) );

	if ( item.title ) {
		$quote.append( $( '<footer class="quote-attribute"></footer>' ).text( item.title ) );
	}

	return $quote;
};

const showInstructions = () => {
	$wrapper.find( '.state-quote' ).remove();
	$instructions.show();
};

const showResults = ( state ) => {
	$instructions.hide();
	$wrapper.find( '.state-quote' ).remove();
	state.results.forEach( ( item ) => $wrapper.append( buildQuote( item ) ) );
};

const bind = () => {
	$select.on( 'change', function() {
		const key = $( this ).val();
		const state = window.stateQuotes && window.stateQuotes[ key ];

		if ( ! key || ! state ) {
			showInstructions();
			return;
		}

		showResults( state );
	} );
};

export default () => {
	if ( ! $select.length ) {
		return;
	}

	bind();
};
